import React from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { generateTestId } from '../../../app/functions';
import { getMediaPath } from '../../../app/functions';
import ReactHtmlParser from 'react-html-parser';
import { PaddingTwoTone } from '@mui/icons-material';

const StyledButton = styled(Button)(({ theme }) => ({
    backgroundColor: theme.palette.brands.text.active,
    color: theme.palette.background.paper,
    borderRadius: "24px",
    padding: "18px 40px",
    width: 325,
    fontWeight: 700,
    fontSize: "24px",
    lineHeight: 1.08,
    textTransform: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing(1.25),
    transition: "all 0.3s ease",
    direction: "ltr",
    "& img": {
      width: 24,
      height: 24,
      order: -1,
    },
    [theme.breakpoints.down("md")]: {
      width: "100%",
      maxWidth: "325px",
      padding: "14px 32px",
      fontSize: "17px",
    },
  }));

const ButtonsWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  gap: theme.spacing(2),
  direction: "rtl",
  justifyContent: "center",
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
    width: "100%",
    alignItems: "center",
    paddingBottom: "40px",
    paddingTop: "40px",
  },
  [theme.breakpoints.up("sm")]: {
    padding: "40px 24px",
  },
  [theme.breakpoints.up("md")]: {
    padding: "48px 28px",
  },
}));

const ContactUsComponent = ({ data, testID = "contact-us-component" }) => (
  <ButtonsWrapper testID={generateTestId(testID, "buttonsWrapper")}>  
    {data.contactButtons.map((button, index) => (
      <StyledButton
        key={index}
        onClick={(event) => { event.preventDefault(); window.open(button.link, '_blank'); }}
        testID={generateTestId(testID, `button-${index}`)}
      >
        {ReactHtmlParser(button.title)}
        <img src={getMediaPath(button.image)} alt={button.title} />
      </StyledButton>
    ))}
  </ButtonsWrapper>
);

export default ContactUsComponent;  